import { forwardRef } from "react";

import { useField } from "formik";
import { TextInput as NativeTextInput } from "react-native";
import {
  TextInput as PaperTextInput,
  TextInputProps,
  useTheme,
} from "react-native-paper";

const TextInput = forwardRef<NativeTextInput, TextInputProps>(
  function TextInput(props, ref) {
    const { colors } = useTheme();

    return (
      <PaperTextInput
        ref={ref}
        mode="outlined"
        returnKeyType="done"
        // eslint-disable-next-line react-native/no-inline-styles
        style={[{ textAlign: "auto" }, props.style]}
        placeholderTextColor={colors.onSurfaceDisabled}
        dense
        {...props}
      />
    );
  }
);

export default TextInput;

type FormikProps = Omit<
  TextInputProps,
  "value" | "onChange" | "onChangeText"
> & {
  fieldName: string;
};
export function FormikTextInput({ fieldName, ...props }: FormikProps) {
  const [field, meta] = useField<string>(fieldName);
  const { colors } = useTheme();

  return (
    <TextInput
      value={field.value}
      onChangeText={field.onChange(fieldName)}
      onBlur={field.onBlur(fieldName)}
      outlineColor={meta.error && meta.touched ? colors.error : undefined}
      {...props}
    />
  );
}
